import { ApolloClient, from } from '@apollo/client';

import typeDefs from './typeDefs';
import resolvers from './resolvers';
import cache from './cache';
import { uploadLink } from './links';

export const client = new ApolloClient({
  // @ts-ignore
  link: from([uploadLink]),
  cache,
  typeDefs,
  resolvers,
});
